var render, staticRenderFns
import script from "./MenuItem.vue?vue&type=script&lang=tsx"
export * from "./MenuItem.vue?vue&type=script&lang=tsx"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=3f86b284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f86b284",
  null
  
)

export default component.exports